export default {
  role: {
    RoleCode: '角色编号',
    RoleName: '角色名称',
    OnlineRegister: '网上注册',
    Custom: '自定义',
    SystemRetention: '系统保留',
    ChooseSystem: '选择系统',
    PleaseChooseSystem: '请选择系统',
    RoleInformation: '角色信息',
    RoleId: '角色Id',
    AuthorityInformation: '授权信息',
    ModelName: '模块名称'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/role.js